import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { setLanguage } from '../../language/actions'
import { getCustomerLanguage } from '../../actions/common'
import { uploadMultipleFiles, getOrderFiles, deleteFileFromOrder, UpdateOrderFileSelection } from '../../actions/orders'
// import { renderFullDate } from '../../utils/time'
import Gallery from '../../shared/components/Gallery'
// import Dropzone from '../../shared/components/Dropzone'

import { API_URL, FILE_STORAGE, FILE_STORAGE_API } from '../../constants'

// Actions
import { updatePrices, getPricesForShopApproval, getPricesForApproval, approvePrices, rejectPrices } from '../../actions/orderPrice'
import { getPriceInformations } from '../../actions/priceModel'
import { createNote } from '../../actions/notes'

// Confirm
import { triggerPopup } from '../../actions/backdrop'
import Portal from '../../shared/components/Portal'
import Confirm from '../../shared/components/Confirm'

// Components
import Header from '../../shared/components/Header'
import HelpText from '../../shared/components/HelpText'
import EstimationsList from '../../shared/components/EstimationsList'

// import Forsi from '../../shared/components/Extent/Forsi'
import AssessmentForsi from '../../shared/components/Extent/AssessmentForsi'
import AssessmentDBS from '../../shared/components/Extent/AssessmentDBS'
import Estimation from '../../shared/components/Extent/Estimation'
import UserInfo from '../../shared/components/UserInfo'

// import styles
import './priceapproval.scss'
// import '../PriceCalculation/Price/price.scss'

// import { hasAccess } from '../../utils/auth'
import { formatCurrency } from '../../utils/currency'

// import utils
import { renderFullDate } from '../../utils/time'
import { translation } from '../../utils/helpers'
import { hasSubscriptionPermission } from '../../utils/auth'
import { formatArrayToString } from '../../utils/array'

// Elements
import Button from '../../shared/elements/button'
import Check from '../../shared/elements/check'
import Text from '../../shared/elements/text'
import Inline from '../../shared/elements/inline'
import Textarea from '../../shared/elements/textarea'
import Divider from '../../shared/elements/divider'
import Grid from '../../shared/elements/grid'
import Col from '../../shared/elements/col'
import Panel from '../../shared/elements/panel'
import CloseButton from '../../shared/elements/closeButton'
import Icon from '../../shared/elements/icon'
import Expand from '../../shared/elements/expand'
import { GeneralIcons } from '../../shared/elements/icons'

class PriceApproval extends Component {

  constructor (props) {
    super(props)
    this.state = {
      prices: {
        Original: {},
        Changed: {},
        IsApproved: false,
        ApprovalToken: '',
        CustomerId: 0,
        Customer: null,
        Shop: null,
        OrderType: 0
      },
      isShopApproval: false,
      shopApproval: {
        orderId: null,
        orderPriceType: null
      },
      note: {
        NoteID: 0,
        Note: '',
        NoteTypeID: 1,
        OrderID: 0,
        SourceID: 0,
        ApplyToInvoice: false,
        DeviationId: 0
      },
      CommentName: '',
      Locked: false,
      toggleGross: false,
      ApprovedText: '',
      confirmImage: false,
      confirm: {
        open: false
      },
      reject: {
        open: false
      },
      approvalResult: null,
      hideXButton: false,
      isHandled: false,
      custommerContacts: [],
      priceInformation: props.priceInformation !== undefined ? props.priceInformation : null,
      employees: [],
      specificReciever: ''
    }

    this.renderContent = this.renderContent.bind(this)
    this.getPricesForApproval = this.getPricesForApproval.bind(this)
    this.renderPrice = this.renderPrice.bind(this)
    this.renderPartTasks = this.renderPartTasks.bind(this)
    this.renderAddonPart = this.renderAddonPart.bind(this)
    this.renderAddonStartTime = this.renderAddonStartTime.bind(this)
    this.renderExtraOrService = this.renderExtraOrService.bind(this)
    this.setLanguage = this.setLanguage.bind(this)
    this.toggleGross = this.toggleGross.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.onApproveClick = this.onApproveClick.bind(this)
    this.onRejectClick = this.onRejectClick.bind(this)
    this.validateFields = this.validateFields.bind(this)
    this.onPortalClose = this.onPortalClose.bind(this)
    this.renderComment = this.renderComment.bind(this)
    this.renderFiles = this.renderFiles.bind(this)
    this.renderHandledBy = this.renderHandledBy.bind(this)
    this.setHeader = this.setHeader.bind(this)
  }

  componentDidMount () {
    let isShopApproval = false
    let orderPriceType = 1  // base
    let orderId = null
    let commentName = '' // this.props.auth.isAuthenticated ? this.props.auth.user.ContactName : ''
    if (this.props.orderId !== undefined && this.props.shopApproval === true) {
      isShopApproval = true
      orderId = this.props.orderId
      orderPriceType = this.props.orderPriceType !== undefined ? this.props.orderPriceType : orderPriceType
      // console.log('orderPriceType', orderPriceType, this.props.orderPriceType)
      if (this.context.router.params.addon === '4') orderPriceType = 4 // Afterevaluation
      if (this.context.router.params.addon === '3') orderPriceType = 3 // Evaluation
      if (this.context.router.params.addon === '2') orderPriceType = 2 // Addon
      let isBodyShop = this.context.router.params.addon === 'bodyextent' || this.context.router.params.addon === 'bodyaddon'

      this.getPricesForShopApproval(orderId, orderPriceType, isBodyShop ? 1 : 0).then(() => {
        // console.log('PriceApproval get for shop ', this.props.priceInformation, this.state.prices.Changed.UseEstimation)
        if (!this.props.priceInformation &&
          (this.state.prices.Changed !== null && (this.state.prices.Changed.UseEstimation || this.state.prices.Changed.IsAfterEvaluation) ||
          this.state.prices.Original !== null && (this.state.prices.Original.UseEstimation || this.state.prices.Original.IsAfterEvaluation))) {
          // console.log('PriceApproval Will get partTasks')
          const { OrderBrand, CustomerId, Changed: { OrderId } } = this.state.prices

          this.props.getPriceInformations(null, OrderBrand, CustomerId, null, true, false, OrderId).then(res => {
            this.setState({
              priceInformation: res.data
            })
          })
        }
      })
    } else {
      let token = this.props.routeParams.approvalToken

      this.getPricesForApproval(token).then(() => {
        if (!this.props.priceInformation && (this.state.prices.Changed.UseEstimation || this.state.prices.Original.UseEstimation)) {
          const { OrderBrand, CustomerId, Changed: { OrderId } } = this.state.prices

          this.props.getPriceInformations(null, OrderBrand, CustomerId, null, true, false, OrderId).then(res => {
            this.setState({
              priceInformation: res.data
            })
          })
        }
      })
    }

    this.setState({
      isShopApproval: isShopApproval,
      shopApproval: {
        orderId: orderId,
        orderPriceType: orderPriceType
      },
      CommentName: commentName
    }, () => {
      if (this.props.renderModal && this.props.setBottomBarProps) {
        this.props.setBottomBarProps(this.getActionButtons(true))
      }
    })
  }

  setHeader () {
    if (this.props.setModalHeader !== undefined && this.props.setModalHeader !== null) {
      if (this.state.prices.Changed !== null) {
        if (this.state.prices.Changed.IsAfterEvaluation) this.props.setModalHeader(translation(14921))
        else if (this.state.prices.Changed.IsEvaluation) this.props.setModalHeader(translation(13363))
        else if (this.state.prices.Changed.IsAddonPrice) this.props.setModalHeader(translation(1045))
      } else {
        this.props.setModalHeader(translation(2012))
      }
    }
  }

  getPricesForApproval (token) {
    return this.props.getPricesForApproval(token).then((res) => {
      let commentName = ''
      let hideXButton = false
      if (res.data === null) {
        this.setState({
          prices: null,
          isHandled: true,
          CommentName: '',
          hideXButton: true
        })
      } else {
        if (res.data.CurrentUserName !== undefined && res.data.CurrentUserName !== null) {
          commentName = res.data.CurrentUserName
        } else {
          hideXButton = true  // Hide X if not logged in
        }
        this.setState({
          prices: res.data,
          CommentName: commentName,
          hideXButton: hideXButton
        }, (res) => {
          this.setLanguage(this.state.prices.CustomerId)
          this.setHeader()
        })
      }
    }, () => {
      this.context.router.goBack()
    })
  }

  getPricesForShopApproval (orderId, type, department) {
    return this.props.getPricesForShopApproval(orderId, type, department).then((res) => {
      let commentName = ''
      if (res.data.CurrentUserName !== undefined && res.data.CurrentUserName !== null) {
        commentName = res.data.CurrentUserName
      }
      const note = res.data.Changed.Notes[0] || this.state.note
      this.setState({
        prices: res.data,
        CommentName: commentName,
        note: note,
        employees: res.data.Employees,
        custommerContacts: res.data.CustommerContacts
      }, (res) => {
        this.setLanguage(this.state.prices.CustomerId)
        this.setHeader()
      })
    })
  }

  setLanguage (customerId) {
    this.props.getCustomerLanguage(customerId).then((res) => {
      let language = res.data.Language
      if (language !== undefined && language !== null) {
        this.props.setLanguage(language)
      }
    })
  }

  handleClick (el) {
    if (el === 'accept') {
      this.props.triggerPopup(!this.state.confirm.open)
      this.setState({
        confirm: {
          open: !this.state.confirm.open
        }
      })
    } else {
      this.props.triggerPopup(!this.state.reject.open)
      this.setState({
        reject: {
          open: !this.state.reject.open
        }
      })
    }
  }

  onPortalClose (type) {
    this.setState({
      [type]: {
        ...this.state[type],
        open: false
      }
    })
    this.props.triggerPopup(false)
  }

  onApproveClick () {
    const approveShop = () => {
      let data = this.state.prices.Changed
      data.SendToApproval = true
      if (!this.state.prices.Changed.IsAfterEvaluation) data.SendToCustomer = true
      data.SelectedContacts = this.state.custommerContacts.concat(this.state.employees)
      if (this.state.specificReciever && this.state.specificReciever.trim().length > 0) {
        data.SelectedContacts.push({ GetMail: true, SpecificReciever: this.state.specificReciever })
      }

      this.props.updatePrices(data).then((res) => {
        this.setState({
          Locked: true,
          ApprovedText: this.state.prices.Changed.IsAddonPrice ? translation(16831) : translation('2333')
        })
        if (this.state.prices.OrderType === 1 && !this.state.prices.Changed.IsAfterEvaluation) {
          // window.toastr.success(translation('15215'), translation('13424'))
        } else if (this.state.prices.Changed.RequireCustomerApproval) {
          // window.toastr.success(translation('2720'), translation('13424'))  // Msg: 'Price change sent to customer...' // was 2016
          // window.toastr.success(translation('2721'), translation('13424'))  // Msg: ''
        } else if (this.state.prices.Changed.IsAfterEvaluation) {
          // window.toastr.success(translation('15217'), translation('13424'))
        } else {
          // window.toastr.success(translation('15215'), translation('13424'))
        }

        let router = this.context.router
        let workcardLocation = '/orders/' + router.params.orderID
        let routeItem = window.LocalstorageStack.findFirst([workcardLocation, '/workscreen', '/orders'])
        if (routeItem !== null) {
          if (routeItem.pathname === '/orders/') {
            router.replace(routeItem.pathname + '' + router.params.orderID)
          } else if (routeItem.pathname === '/orders') {
            router.replace(routeItem.pathname + '?orderid=' + router.params.orderID)
          } else {
            router.replace(routeItem.pathname)
          }
        } else {
          if (!this.context.router.location.pathname.includes('/orders/')) {
            this.context.router.push('/orders?orderid=' + this.state.prices.Changed.OrderId)
          } else {
            this.props.modalCloseCB(false)
          }
        }
      }, () => {
          // Toastr
        window.toastr.error(translation('2009'), translation('216'))
        this.setState({
          Locked: false
        })
      })
      // })
    }

    const approveCustomer = () => {
      this.props.approvePrices(this.state.prices.ApprovalToken, this.state.CommentName, this.state.CommentText).then((res) => {
        this.setState({
          Locked: true,
          ApprovedText: this.state.prices.Changed.IsAddonPrice ? translation(16831) : translation('2333'),
          approvalResult: res.data
        })

        // Toastr
        // window.toastr.success(translation('2008'), translation('13424'))
        // this.props.router.push('/orders?orderid=' + this.state.prices.Changed.OrderId)
      }, () => {
        // Toastr
        window.toastr.error(translation('2009'), translation('216'))
        this.setState({
          Locked: false
        })
      })
    }

    if (this.validateFields(0)) {
      this.setState({
        Locked: true
      })
      if (this.state.isShopApproval) {
        approveShop()
      } else {
        approveCustomer()
      }
    }
  }

  onRejectClick () {
    const rejectShop = () => {
      if (this.props.modalCloseCB === undefined || this.props.modalCloseCB === null) {
      } else {
        this.props.modalCloseCB(true)
      }
    }

    const rejectCustomer = () => {
      this.props.rejectPrices(this.state.prices.ApprovalToken, this.state.CommentName, this.state.CommentText).then((res) => {
        this.setState({
          Locked: true,
          ApprovedText: translation('2334'),
          approvalResult: res.data
        })

        // Toastr
        // window.toastr.success(translation('2010'), translation('13424'))
        this.context.router.push('/orders?orderid=' + this.state.prices.Changed.OrderId)
      }, () => {
        // Toastr
        window.toastr.error(translation('2011'), translation('216'))
        this.setState({
          Locked: false
        })
      })
    }

    if (this.state.isShopApproval) {
      rejectShop()
    } else {
      if (this.validateFields(1)) {
        rejectCustomer()
      }
    }
  }

  validateFields (type) {
    if (this.state.CommentName === undefined || this.state.CommentName.trim() === '') {
      window.toastr.error(translation('2243'), translation('216'))
      return false
    }
    return true
  }

  getActionButtons (asProps = false) {
    const isAfterEvaluation = this.state.prices.Changed.IsAfterEvaluation

    let confirmBtnText = translation('752')
    if ((this.state.isShopApproval === true && this.state.prices.Changed.RequireCustomerApproval) || isAfterEvaluation) {
      confirmBtnText = translation('1022')
    }
    if (!isAfterEvaluation && this.state.prices.OrderType === 1) {
      confirmBtnText = translation('752')
    }

    if (asProps) {
      return {
        actionLabelText: confirmBtnText,
        onActionClick: this.handleClick.bind(this, 'accept'),
        cancelLabelText: this.state.isShopApproval === true ? translation('1155') : translation('753'),
        onCancelClick: this.handleClick.bind(this, 'reject')
      }
    }

    return (
      <Inline fillChildNum={[0, 1]} block>
        <Button
          disabled={this.state.Locked}
          onClick={this.handleClick.bind(this, 'accept')}
          labelText={confirmBtnText}
        />
        <Button
          style='alert'
          disabled={this.state.Locked}
          onClick={this.handleClick.bind(this, 'reject')}
          labelText={this.state.isShopApproval === true ? translation('1155') : translation('753')}
        />
      </Inline>
    )
  }

  renderFiles (onlyPhotos) {
    let { Files } = this.state.prices.Changed
    // let { oldFiles } = this.state
    let allFiles = Files.concat(this.state.prices.Changed.SelectedOldFiles)
    if (allFiles === undefined || allFiles === null) {
      allFiles = []
    }
    let files = allFiles

    // Render image
    const renderImage = (image, index) => {
      // Image key
      let imageKey = this.state.imageKey + '_' + index + '_' + image.OrderFileID
      // Url
      let url = FILE_STORAGE + image.ThumbURL + '?' + imageKey
      let fullUrl = FILE_STORAGE + image.FileURL + '?' + imageKey
      // set grayout class
      let oldImgClass = 'testImg'
      if (image.oldFile && image.checked !== true) {
        oldImgClass += ' grayout'
      }

      if (this.state.isShopApproval === true) {
        return (
          <div key={index}>
            <div className='divImg'>
              <a href={fullUrl} data-lightbox='gallery' data-title={image.FileName}>
                <img className={oldImgClass} id={image.OrderFileID} name='oldImages' src={url} key={imageKey} />
              </a>
            </div>
          </div>
        )
      } else {
        return (
          <div key={index}>
            <div className='divImg'>
              <a href={fullUrl} data-lightbox='gallery' data-title={image.FileName}>
                <img className='testImg' id={image.OrderFileID} name='oldImages' src={url} key={imageKey} />
              </a>
            </div>
          </div>
        )
      }
    }

    // Render other files
    const renderOtherFile = (file, index) => {
      if (file.OrderFile !== undefined) {
        file = file.OrderFile
      }
      // let fileUrl = file.FileURL.replace('API/', '')
      if (file.ActualFileName === null) return null
      let newFileUrl = FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + file.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token)
      let thumbUrl = API_URL + '/FileService/GetIcon?fileName=' + file.FileName
      const deleteFile = () => {
        this.setState({
          confirmImage: file
        })
      }
      return (
        <div key={index} className='file-document clearfix'>
          <img className='file-icon' alt='icon' src={thumbUrl} />
          <a target='_BLANK' href={newFileUrl}>
            {file.FileName}
          </a>
          <img className='file-delete' src='/images/icons/Delete_16.png' onClick={deleteFile} />
        </div>
      )
    }
    // Filter files
    let imgFiles = files.filter((file) => {
      if (file.OrderFile !== undefined) file = file.OrderFile
      return ((file.OrderFileID !== undefined || file.Id !== undefined) && file.IsImage) ? file : false
    })
    let otherFiles = files.filter((file) => {
      if (file.OrderFile !== undefined) file = file.OrderFile
      return (file.IsImage || (file.Id === undefined && file.OrderFileID === undefined)) ? false : file
    })

    if (onlyPhotos) {
      if (imgFiles.length === 0 && otherFiles.length === 0) return null
      return (
        <div className='price_photo'>
          <h3>{translation('1011')}</h3>
          <Divider />
          {otherFiles.map(renderOtherFile)}
          <Gallery files={imgFiles} renderImage={renderImage} />
        </div>
      )
    }
  }

  renderComment () {
    let { note } = this.state
    // Create / Save
    const onChange = (e) => {
      e.persist()
      let value = e.target.value
      if (e.target.type === 'checkbox') {
        value = e.target.checked
        if (e.target.name === 'NoteTypeID') {
          value = (value) ? 1 : 0
        }
      }
      this.setState({
        note: {
          ...this.state.note,
          [e.target.name]: value
        }
      }, () => {
        if (e.target.type === 'checkbox') {
          createSave(e)
        }
      })
    }
    const createSave = (e) => {
      let note = { ...this.state.note }
      note.OrderPrices = [this.state.prices.Changed.OrderPriceId]
      note.OrderID = this.state.prices.Changed.OrderId
      note.SourceID = 11 // PriceChange
      note.NoteUserName = this.state.CommentName
      note.ApprovalToken = this.props.routeParams.approvalToken
      this.props.createNote(note).then((res) => {
        let newNote = res.data
        this.setState({
          note: newNote
        })
      }, () => {
        window.toastr.error(translation('1917'), translation('216'))
      })
    }
    if (this.state.isShopApproval && (note.Note === undefined || note.Note === null || note.Note === '')) return null
    // Render
    return (
      <div>
        <h3>{translation('149')}</h3>
        <Divider />
        {!this.state.isShopApproval && <Textarea name='Note' onBlur={createSave} value={note.Note} onChange={onChange} />}
        {this.state.isShopApproval && <div>{formatArrayToString(note.Note)}</div>}
      </div>
    )
  }

  renderSendTo () {
    if (this.state.isShopApproval === false) return null
    if (!hasSubscriptionPermission(this.props.auth, 30)) return null

    const contact = (listName, val, key) => {
      const onChange = (e) => {
        e.persist()
        let list = this.state[listName]
        list[key][e.target.name] = e.target.checked

        this.setState({
          [listName]: list
        })
      }
      return (
        <Inline key={key} fillChildNum={[0]} block>
          {val.Name}
          <Check simple name='GetMail' onChange={onChange} checked={val.GetMail} disabled={val.HasMail === false} onClick={() => val.HasMail === false ? window.toastr.error(translation('2727'), translation('216')) : ''} />
          <Check simple name='GetPhone' onChange={onChange} checked={val.GetPhone} disabled={val.HasPhone === false} onClick={() => val.HasPhone === false ? window.toastr.error(translation('2728'), translation('216')) : ''} />
        </Inline>
      )
    }

    // Render
    return (
      <div>
        <h3>{translation('2726')}</h3>
        <Divider />
        <ul className='notifications__list'>
          <Expand title={translation('13601')} defaultOpen>
            <Inline fillChildNum={[0]} block>
              <span />
              <span>{translation('1052')}</span>
              <span>{translation('15')}</span>
            </Inline>
            {this.state.custommerContacts.map(contact.bind(this, 'custommerContacts'))}
          </Expand>
          <Divider noLine size={2} />
          <Divider />
          <Expand title={translation('16664')}>
            {this.state.employees.map(contact.bind(this, 'employees'))}
          </Expand>
          <Divider noLine />
          <Text labelText={1052} value={this.state.specificReciever} onChange={(e) => { this.setState({ specificReciever: e.target.value }) }} />
        </ul>
      </div>
    )
  }

  renderContent () {
    let price = !this.state.prices.Original ? this.state.prices.Changed : this.state.prices.Original
    let orderId = price.OrderId

    let hasCommentAndFilePermission = true

    if (orderId === undefined || orderId === null) {
      return null
    }
    let pices = [this.state.prices.OrderRegNr, translation('' + this.state.prices.OrderBrand === '2000' ? '' : this.state.prices.OrderBrand), this.state.prices.OrderModel]
    pices = pices.filter(x => x !== '' && x !== ' ' && x !== null)
    if (pices.length === 0) {
      pices = [this.props.orderId]
    }
    // Text below title. Texts for shop approval, customer approval of price change, and text for shop approval of after evaluation.
    let text = (this.props.RequireCustomerApproval ? translation('2711') : translation('2013'))
    if (this.state.prices.Changed.IsAfterEvaluation) {
      text = translation(15205)
    } else if (this.state.prices.Changed.IsEvaluation) {
      text = translation(16665)
    } else if (this.state.prices.Changed.IsAddonPrice) {
      text = translation(16826)
    } else if (this.state.prices.OrderType === 1) {
      // no matter what, insurance orders should not be send to the customer
      text = translation('15229')
    }
    text = text.replace('[OrderId]', orderId)

    let title = translation('2014') + ('\n' + pices.join(', '))
    if (title.includes('[OrderId]')) {
      price.OrderId !== undefined ? title = title.replace('[OrderId]', price.OrderId) : title = title.replace('[OrderId]', this.props.orderId)
    }
    if (text.includes('[OrderId]')) {
      price.OrderId !== undefined ? text = text.replace('[OrderId]', price.OrderId) : text = text.replace('[OrderId]', this.props.orderId)
    }

    let deliveryText = ''
    let approval = this.state.approvalResult
    if (approval !== undefined && approval !== null && approval.Success) {
      if (approval.DeliveryTimeChanged) {
        deliveryText = (translation('2722')).replace('[DeliveryTime]', renderFullDate(approval.DeliveryTime)) // Note: the delivery time is changed to [DeliveryTime]!
      } else {
        deliveryText = (translation('2725'))
      }
    }

    // console.log(this.state.approvalResult, deliveryText)
    let original = !this.state.prices.Original ? this.state.prices.Changed : this.state.prices.Original
    let changed = this.state.prices.Changed
    let isTheSame = Number(original.OrderPriceId) === Number(changed.OrderPriceId)
    let isAfterEvaluation = changed.IsAfterEvaluation
    let isEvaluation = changed.IsEvaluation
    let isAddonPrice = changed.IsAddonPrice

    const renderOrderInfo = () => {
      let customer = this.state.prices.Customer
      let shop = this.state.prices.Shop
      if (customer === null || shop === null) return null

      return (
        <div>
          <h3>{translation('13420')}</h3>
          <Divider />
          <Grid align='start'>
            <div>{customer.Name}</div>
            <div>{shop.Name}</div>
          </Grid>
          <Grid aling='start'>
            <div>{customer.Address}</div>
            <div>{shop.Address}</div>
          </Grid>
          <Grid align='start'>
            <div>{customer.Zip} {customer.City ? ',' : ''} {customer.City}</div>
            <div>{shop.Zip}{shop.City ? ',' : ''} {shop.City}</div>
          </Grid>
          <Grid align='start'>
            <div>{customer.PhoneCode} {customer.Phone}</div>
            <div>{shop.PhoneCode} {shop.Phone}</div>
          </Grid>
        </div>
      )
    }

    const carData = () => {
      let customer = this.state.prices.Customer
      let shop = this.state.prices.Shop
      if (customer === null || shop === null) return null

      let orderBrand = this.state.prices.OrderBrand
      let orderChassisNr = this.state.prices.OrderChassisNr
      let orderModel = this.state.prices.OrderModel
      let orderRegNr = this.state.prices.OrderRegNr
      let orderRekvNr = this.state.prices.OrderRekvNr

      return (
        <div>
          <h3>{translation('77')}</h3>
          <Divider />
          <Inline fillChildNum={[0]} block>
            {translation('145')}
            {translation(orderBrand)}
          </Inline>
          <Inline fillChildNum={[0]} block>
            {translation('146')}
            {orderModel}
          </Inline>
          <Inline fillChildNum={[0]} block>
            {translation('2005')}
            {orderRegNr}
          </Inline>
          <Inline fillChildNum={[0]} block>
            {translation('81')}
            {orderChassisNr}
          </Inline>
          <Inline fillChildNum={[0]} block>
            {translation('1337')}
            {orderRekvNr}
          </Inline>
        </div>
      )
    }

    const changedBy = () => {
      if (this.state.isShopApproval) return null
      // console.log(this.state)
      let createdBy = this.state.prices.Changed.CreatedBy
      return (
        <div>
          <h3>{translation(2713)}</h3>
          <Divider />
          <Inline fillChildNum={[0]} block>
            {createdBy && <div className='left'><UserInfo user={createdBy.UserInfo} />{((createdBy.Email !== null && createdBy.Email.length > 0) || (createdBy.Phone !== null && createdBy.Phone.length > 0)) && <HelpText className='helpText' text={createdBy.Email + '\n' + createdBy.Phone} />}</div>}
            {this.state.prices.Changed.Notes && <div className='left'>{this.state.prices.Changed.Notes !== undefined && this.state.prices.Changed.Notes.length > 0 && this.state.prices.Changed.Notes[0].Note || ''}</div>}
          </Inline>
        </div>
      )
    }

    const onChange = (e) => {
      this.setState({
        [e.target.name]: e.target.value
      })
    }

    if (!this.state.Locked) {
      // console.log('priceapproval state: ', this.state, 'props', this.props)
      let confirmText = ''
      let rejectText = ''

      if (this.state.isShopApproval && this.state.prices.Changed.RequireCustomerApproval) {
        confirmText = this.state.prices.Changed.IsAddonPrice ? translation(16827) : translation(2723)
        rejectText = this.state.prices.Changed.IsAddonPrice ? translation(16828) : translation(2724)
      } else {
        confirmText = this.state.prices.Changed.IsAddonPrice ? translation(16830) : translation(15216)
        rejectText = this.state.prices.Changed.IsAddonPrice ? translation(16829) : translation(2724)
      }

      let willSendToCustomers = Array.isArray(this.state.custommerContacts) && this.state.custommerContacts.some(c => c.GetMail || c.GetPhone)
      if (this.state.prices.Changed.IsAfterEvaluation) {
        // if (this.state.prices.Changed.SendToCustomer) {
        if (willSendToCustomers) {
          confirmText = translation(15218)
          rejectText = translation(15219)
        } else {
          confirmText = translation(15220)
          rejectText = translation(15219)
        }
      } else if (this.state.prices.Changed.IsEvaluation) {
        confirmText = translation(16666)
        rejectText = translation(16667)
      } // else if (this.state.prices.OrderType === 1) {
      //   confirmText = translation(15216)
      //   rejectText = translation(2724)
      // }

      return (
        <div className='priceapprove__screen--inner'>
          <Col span='2'>
            <Panel title={title}>
              <div>{text}<br /><br /><br /></div>
              {renderOrderInfo()}
              {changedBy()}
              {carData()}
              {this.renderPrice('first', original, (isAfterEvaluation || isEvaluation) ? translation(15206) : translation(2006), isTheSame, isAfterEvaluation || isEvaluation)}
              {this.renderPrice('second', changed, (isAfterEvaluation || isEvaluation) ? translation(15172) : isAddonPrice ? translation(1045) : translation(2007), false, isAfterEvaluation || isEvaluation)}
              {hasCommentAndFilePermission && this.renderComment()}
              {hasCommentAndFilePermission && this.renderFiles(true)}
              {this.renderSendTo()}
              <div>
                <h3>{translation('752')}</h3>
                <Divider />
                {this.renderHandledBy()}
              </div>

              {!this.props.renderModal && <Divider size={3} noLine />}
              {!this.props.renderModal && this.getActionButtons()}

              {(this.state.confirm.open) && (
                <Portal className='deleteModal' onPortalClose={this.onPortalClose.bind(this, 'confirm')}>
                  <Confirm
                    renderText={() => { return (<div className='pg-pb-2'>{confirmText}</div>) }}
                    confirm={this.onApproveClick}
                    notConfirm={this.onPortalClose.bind(this, 'confirm')}
                  />
                </Portal>
              )}
              {(this.state.reject.open) && (
                <Portal className='deleteModal' onPortalClose={this.onPortalClose.bind(this, 'reject')}>
                  <Confirm
                    renderText={() => { return (<div className='pg-pb-2'>{rejectText}</div>) }}
                    confirm={this.onRejectClick}
                    notConfirm={this.onPortalClose.bind(this, 'reject')}
                  />
                </Portal>
              )}
            </Panel>
          </Col>
        </div>
      )
    } else {
      return (
        <div className='priceapprove__screen--inner'>
          <Col span='2'>
            <Panel title={title}>
              <div>{text}<br /><br /><span className='deliveryText'>{deliveryText}</span><br /><br /></div>
              {renderOrderInfo()}
              {hasCommentAndFilePermission && this.renderFiles(true)}
              {this.renderPrice('first', original, (isAfterEvaluation || isEvaluation) ? translation(15206) : translation(2006))}
              {this.renderPrice('second', changed, isAddonPrice ? translation(1045) : translation('2007'))}
              <h3>{translation('752')}</h3>
              <Divider />
              <Text labelText={translation('30')} name='CommentName' id='CommmentName' disabled={this.state.Locked} defaultValue={this.state.CommentName} onChange={onChange} />
              <div className='button_bar' style={{ alignItems: 'center', textAlign: 'center' }}>
                {this.state.ApprovedText}
              </div>
            </Panel>
          </Col>
        </div>
      )
    }
  }

  renderHandledBy () {
    if (this.state.prices.CurrentUserName !== null) {
      if (this.state.isShopApproval) {
        return <div>{translation('13564')} {this.state.CommentName}</div>
      } else {
        return <div>{translation('2712')} {this.state.CommentName}</div>
      }
    } else {
      return (
        <Inline block>
          <span>{translation('2712')}</span>
          <Text value={this.state.CommentName} onChange={(e) => { this.setState({ CommentName: e.target.value }) }} />
        </Inline>
      )
    }
  }

  renderPartTasks (part, key) {
    const renderTask = (task, key) => {
      let price = this.state.toggleGross ? task.Gross : task.Net
      return (
        <Inline fillChildNum={[1]} block key={'task_' + key}>
          &nbsp;&nbsp;&nbsp;-
          {task.TaskName}
          {formatCurrency(price)}
        </Inline>
      )
    }
    const renderEstimationTask = (task, key) => {
      let extraTasks = ''
      let extraText = ''
      if (typeof task.EstimationTaskId !== 'undefined') {
        extraText = (task.Extent === null) ? '' : task.Extent.Type
        let thousandClass = (task.EstimationTaskId === 0 && extraText === '') ? 'alone' : ''
        extraTasks = (
          <div className={'extraThousands ' + thousandClass}>
            {task.Extras && task.Extras.map((val, key) => {
              let valMatText = ''
              if (this.props.showAE) {
                if (val.AE !== 0 || val.Material !== 0) {
                  let commaSep = ''
                  if (val.AE !== 0 && val.Material !== 0) commaSep = ', '
                  valMatText += '('
                  if (val.AE !== 0) valMatText += val.AE + ' ' + translation('885')
                  valMatText += commaSep
                  if (val.Material !== 0) valMatText += val.Material + ' ' + translation('13338')
                  valMatText += ')'
                }
              }
              let content = val.Name + ' ' + valMatText
              return (
                <div key={key}>
                  {content}
                </div>
              )
            })}
          </div>
        )
      }
      return (
        <li className='clearfix' key={'task_' + key}>
          <div>&nbsp;&nbsp;&nbsp;- {task.TaskName} {extraText}</div>
          {extraTasks}
        </li>
      )
    }

    let partName = part.Part.Name
    let side = ''
    let frontBack = ''

    if (part.Part.PartItemId === 0) {
      partName = translation('227')
    }

    if (part.Part.TaskSide !== 0) {
      switch (part.Part.TaskSide) {
        case 1:
          side = translation('213')  // Left
          break
        case 2:
          side = translation('214')  // Right
          break
        case 5:
          side = translation('213')  // Left
          frontBack = translation('287') // Front
          break
        case 6:
          side = translation('214')  // Right
          frontBack = translation('287') // Front
          break
        case 7:
          side = translation('213')  // Left
          frontBack = translation('288') // Back
          break
        case 8:
          side = translation('214')  // Right
          frontBack = translation('288') // Back
          break
      }
    }

    let hasTasks = part.Tasks !== null && part.Tasks.length > 0
    let tasks = part.Tasks
    let PNumber = part.Part.PNumber ? '(' + part.Part.PNumber + ')' : ''
    let estimationTasks = part.EstimationTasks
    let hasEstimationTasks = estimationTasks !== null && estimationTasks.length > 0
    return (
      <li key={'part_' + key}>
        <ul>
          <li className='clearfix'>
            <div className='left'><strong className='price-approval_partname'>{side} {partName} {frontBack} {PNumber}</strong></div>
            <div className='right' />
          </li>
          {(hasTasks) && (tasks.map(renderTask))}
          {hasEstimationTasks && estimationTasks.map(renderEstimationTask)}
        </ul>
      </li>
    )
  }

  renderAddonPart (addon, key) {
    let price = this.state.toggleGross ? addon.Price : addon.Net
    return <Inline fillChildNum={[0]} block key={'addonpart_' + key}>{addon.Name}{formatCurrency(price)}</Inline>
  }

  renderAddonStartTime (addon, key) {
    let price = this.state.toggleGross ? addon.Price : addon.Net
    return <Inline fillChildNum={[0]} block key={'addonstarttime_' + key}>{addon.Name}{formatCurrency(price)}</Inline>
  }

  renderExtraOrService (service, key) {
    let price = this.state.toggleGross ? service.Total : service.Net
    let count = service.Count > 1 ? '(' + service.Count + ' ' + translation('1443') + ')' : ''
    return <Inline fillChildNum={[0]} block key={(service.IsExtra ? 'extra' : 'service') + '_' + key}>{service.TaskName + ' ' + count}{formatCurrency(price)}</Inline>
  }

  toggleGross () {
    this.setState({toggleGross: !this.state.toggleGross})
  }

  renderPrice (location, price, title, isTheSame, isAfterEvaluation) {
    let isReport = location === 'first' && isAfterEvaluation && price.Report !== null && price.Report.ReportId !== 0
    if (isReport) {
      return (
        <div className='extent-content'>
          <h3>{title}</h3>
          <Divider />
          {price.Report.ReportType === 3 ? <AssessmentDBS order={this.state.prices} showPrices showAE /> : <AssessmentForsi order={this.state.prices} showPrices showAE />}
        </div>
      )
    }

    if (isAfterEvaluation && !isReport) {
      if (isTheSame) return null
      // Show estimation component.
      return (
        <div className='extent-content'>
          <h3>{title}</h3>
          <Divider />
          <Estimation
            overrideInnerTitle={''}
            orderPrice={price}
            partTasks={this.props.priceInformation || this.state.priceInformation}
            editable={false}
          />
        </div>
      )
    }
    let hasParts = price.Parts !== undefined && price.Parts !== null && price.Parts.length > 0
    let hasExtras = price.Extras !== undefined && price.Extras !== null && price.Extras.length > 0
    let hasServices = price.Services !== undefined && price.Services !== null && price.Services.length > 0
    let hasAddonParts = price.OrderAddonParts !== undefined && price.OrderAddonParts !== null && price.OrderAddonParts.length > 0
    let hasAddonStartTimes = price.OrderAddonStartTimes !== undefined && price.OrderAddonStartTimes !== null && price.OrderAddonStartTimes.length > 0
    let hasPriceInformation = !!(this.props.priceInformation || this.state.priceInformation)
    let netp = price.Net
    let gross = price.Gross
    let env = price.Environment
    let startPrice = this.state.toggleGross ? price.StartPrice : price.StartPriceNet
    let hasTotalAndNoOtherPrice = netp === 0 && gross === 0 && (price.Total !== 0 || env !== 0)
    let isInsuranceNoPrice = this.state.prices.OrderType === 1 && netp === 0 && gross === 0 && price.Total === 0 && env === 0
    let showGrossNet = !isAfterEvaluation && !price.UseEstimation && !(hasTotalAndNoOtherPrice || isInsuranceNoPrice)

    const renderGross = () => {
      return (
        <Inline fillChildNum={[0]} block key='gross'>
          {translation('13350')}
          {formatCurrency(gross)}
        </Inline>
      )
    }

    const renderNet = () => {
      return (
        <Inline fillChildNum={[0]} block key='netp'>
          {translation('1305')}
          {formatCurrency(netp)}
        </Inline>
      )
    }

    const renderTotal = () => {
      return (
        <Inline fillChildNum={[0]} block key='total'>
          {translation('641')}
          {formatCurrency(price.Total)}
        </Inline>
      )
    }

    const renderEnv = () => {
      return (
        <Inline fillChildNum={[0]} block key='env'>
          {translation('13339')}
          {formatCurrency(env)}
        </Inline>
      )
    }

    const renderSpacing = () => {
      return (
        <div className='clearfix totals-spacing'>&nbsp;</div>
      )
    }

    return (
      <div className='priceview '>
        {showGrossNet && <Inline fillChildNum={[0]} block><h3>{title}</h3><Button style='link' size='m' onClick={this.toggleGross} labelText={translation(this.state.toggleGross ? '13350' : '1305')} /></Inline>}
        {!showGrossNet && <h3>{title}</h3>}
        <Divider />
        <ul>
          {startPrice > 0 && (
          <Inline fillChildNum={[0]} block>
            {translation('1285')}
            {formatCurrency(startPrice)}
          </Inline>
          )}
          {(hasParts) && (price.Parts.map(this.renderPartTasks))}
          {(hasExtras) && (price.Extras.map(this.renderExtraOrService))}
          {(hasServices) && (price.Services.map(this.renderExtraOrService))}
          {(hasAddonParts) && (price.OrderAddonParts.map(this.renderAddonPart))}
          {(hasAddonStartTimes) && (price.OrderAddonStartTimes.map(this.renderAddonStartTime))}
          {(hasPriceInformation) && (
            <EstimationsList priceInformation={this.props.priceInformation || this.state.priceInformation} price={price} />
          )}
          {!isAfterEvaluation && showGrossNet && renderSpacing()}
          {!isAfterEvaluation && showGrossNet && renderEnv()}
          {!isAfterEvaluation && showGrossNet && renderNet()}
          {!isAfterEvaluation && showGrossNet && renderGross()}
          {!isAfterEvaluation && !showGrossNet && renderSpacing()}
          {!isAfterEvaluation && !showGrossNet && renderTotal()}
          {!isAfterEvaluation && !showGrossNet && renderEnv()}
        </ul>
      </div>
    )
  }

  renderLeftBefore () {
    return <Icon icon={GeneralIcons.Apromas_Logo} size='l' />
  }

  render () {
    if (!this.state.isHandled && (this.state.prices === undefined || this.state.prices === null)) return null

    const headerButtonsGoBack = (router, t) => {
      if (!this.props.auth.isAuthenticated || this.state.hideXButton === true) return null
      const goBack = () => {
        this.context.router.goBack()
      }
      return (
        <div>
          {/* <div className='hint--left' aria-label={t('2060')}><img src='/images/icons/close_24.png' onClick={goBack} className='icon' /></div> */}
          <CloseButton spacing={0} ariaLabel={t('2060')} onClick={goBack} />
        </div>
      )
    }

    if (this.state.isHandled) {
      return (
        <div className='priceapprove__screen'>
          <Header router={this.context.router} renderLeftBefore={this.renderLeftBefore} title={translation('2012')} icon={'menu/Prices-White.png'} showBack headerButtonsGoBack={headerButtonsGoBack} />
          <div className='middle'>
            <div>
              {translation('13039')}
            </div>
          </div>
        </div>
      )
    }

    if (this.props.renderModal !== undefined && this.props.renderModal) {
      return (
        <div className='priceapprove__screen'>
          {this.renderContent()}
        </div>
      )
    } else {
      return (
        <div className='priceapprove__screen'>
          <Header router={this.context.router} renderLeftBefore={this.renderLeftBefore} title={translation('2012')} icon={'menu/Prices-White.png'} showBack headerButtonsGoBack={headerButtonsGoBack} />
          {this.renderContent()}
        </div>
      )
    }
  }
}

PriceApproval.propTypes = {
  auth: PropTypes.object.isRequired
}

PriceApproval.contextTypes = {
  router: React.PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  triggerPopup,
  getPricesForShopApproval,
  getPricesForApproval,
  approvePrices,
  rejectPrices,
  getCustomerLanguage,
  setLanguage,
  uploadMultipleFiles,
  updatePrices,
  getPriceInformations,
  createNote,
  getOrderFiles,
  deleteFileFromOrder,
  UpdateOrderFileSelection
})(PriceApproval)



// WEBPACK FOOTER //
// ./src/app/pages/PriceApproval/index.js